import Yup from 'src/yup';

export const validations = Yup.object().shape({
  username: Yup.string().trim().email('Invalid Email address').required('Required'),
  password: Yup.string().trim().required('Required'),
});
